import React, { useState } from 'react';

function SurveyStepFourteen({ formData, onNext }) {
    const [communicationRating, setCommunicationRating] = useState(formData.communicationRating || '');
    const [communicationComments, setCommunicationComments] = useState(formData.communicationComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!communicationRating) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ communicationRating, communicationComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 3: Patient Safety & Service</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How clear and effective do you think communication with patients/customers is? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`communication-rating-${option}`}
                            name="communicationRating"
                            value={option}
                            checked={communicationRating === option}
                            onChange={() => setCommunicationRating(option)}
                        />
                        <label htmlFor={`communication-rating-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={communicationComments}
                    onChange={(e) => setCommunicationComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!communicationRating}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepFourteen;
